<template>
    <div id="r2s2">
        <h2 class="title">
            {{ $t('f_r2s2_title') }}
        </h2>

        <div class="own-input">
            <label>{{ $t('f_number_of_passenger_label') }}</label>
            <count-input
                v-model="people"
                :decrement="removeLastTraveler"
                :increment="addTraveler"
                readonly
                text="" />
        </div>

        <span class="warning-message">
            {{ $t('f_fellow_travelers_warning') }}
        </span>

        <div class="owner traveler-component">
            <div class="title">
                {{ $t('f_passanger_title') }}
            </div>
            <div class="own-input">
                <label for="owner_name">{{ $t('f_name_label') }}</label>
                <input
                    id="owner_name"
                    v-model="name"
                    v-validate="'required'"
                    v-m-android-focus
                    name="travelers[0][name]"
                    :placeholder="$t('f_name_placeholder')"
                    type="text">
                <span v-if="errors.first(`travelers[0][name]`)" class="error-message">
                    {{ errors.first(`travelers[0][name]`) }}
                </span>
            </div>
            <div class="own-input">
                <label for="owner_email">{{ $t('f_email_label') }}</label>
                <input
                    id="owner_email"
                    v-model="email"
                    v-validate="'required|email'"
                    v-m-android-focus
                    name="travelers[0][email]"
                    placeholder="your@email.com"
                    type="email">
                <span v-if="errors.first(`travelers[0][email]`)" class="error-message">
                    {{ errors.first(`travelers[0][email]`) }}
                </span>
            </div>
        </div>

        <r2s1traveler
            v-for="(traveler, i) of filteredTravelersList"
            :key="i+1"
            :index="i+1"
            :traveler="traveler" />

        <div class="add-traveler" @click="addTraveler">
            <span class="plus">+</span> <span class="underline">{{ $t('f_add_traveler_btn') }}</span>
        </div>

        <server-errors v-if="serversErrors" :message="serversErrors" />
        <div class="own-input next-prev-wrap">
            <div class="btn btn-link prev" @click="prevStep">
                &#10092; {{ $t('f_back') }}
            </div>
            <div :class="['btn btn-orange', {'invalid': formIsInvalid(), 'progress': loading}]" @click="next">
                <span v-show="!loading">{{ $t('f_continue') }} &#10093;</span>
                <div v-if="loading" class="spinner">
                    <div class="rect1" />
                    <div class="rect2" />
                    <div class="rect3" />
                    <div class="rect4" />
                    <div class="rect5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import {createHelpers} from 'vuex-map-fields'
  import CountInput from '../common/CountInput'
  import formNavMixin from '../mixins/formNavMixin'
  import R2s1traveler from './R2s2traveler'

  const { mapFields } = createHelpers({
    getterType: 'round2/getComplaintField',
    mutationType: 'round2/UPDATE_COMPLAINT_FIELD'
  })

  const { mapMultiRowFields } = createHelpers({
    getterType: 'travelers/getField',
    mutationType: 'travelers/updateField'
  })

  export default {
    components: { CountInput, R2s1traveler },
    mixins: [formNavMixin],
    data() {
      return {
        module: 'round2'
      }
    },
    computed: {
      ...mapFields([
        'name',
        'email'
      ]),
      people: function(){
        return this.$store.state.travelers.people
      },
      ...mapMultiRowFields({
        travelersList: 'list'
      }),
      filteredTravelersList: function(){
        return this.travelersList.filter((traveler) => !traveler.for_destroy)
      }
    },
    methods: {
      ...mapMutations({
        addTraveler: 'travelers/ADD',
        removeTraveler: 'travelers/REMOVE',
        prev: 'round2/PREV_STEP'
      }),
      removeLastTraveler: function() {
        let lastItem = this.filteredTravelersList[this.filteredTravelersList.length - 1]
        if (lastItem){ this.removeTraveler(lastItem.id) }
      },
      next(){
        this.formSubmittion({scope: `*`, formSelector: '#r2s2'}).then(({success, fail}) => {
          this.$store.dispatch("round2/putAuthorization", this.$store.getters['round2/r2s2FormData']).then(() => {
            this.$store.commit('round2/NEXT_STEP')
            success()
          }).catch((response) => {
            fail(response)
          })
        })
      },
    }
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  #r2s2 {

    .info-tip.bottom {
      .content {
        top: 26px;
      }
    }

    .add-traveler {
      color: $orange_a;
      cursor: pointer;
      font-weight: 400;
      padding-bottom: 10px;
      border-bottom: 1px solid rgb(235, 235, 235);

      .plus {
        font-size: 27px;
        font-weight: 600;
        vertical-align: middle;
      }
      &:hover{
        .underline {
          text-decoration: underline;
        }
      }
    }

  }
</style>
